import React from 'react';
import type { WorkflowEdgeProps } from 'flow/service/graph';
import BaseEdge from '../BaseEdge';


function NormalEdge(props: WorkflowEdgeProps) {
  return (
    <BaseEdge
      {...props}
    />
  );
}

export default React.memo(NormalEdge);
